import {
  Provider,
  msalAtom,
  sessionAtom,
  sessionProviderAtom,
} from '@/domains/appShell/stores/auth.store'
import { userAtom } from '@/domains/appShell/stores/user.store'

import { useCallback } from 'react'

import * as Sentry from '@sentry/react'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'

export const useLogout = () => {
  const msal = useAtomValue(msalAtom)

  const setUser = useSetAtom(userAtom)
  const setSession = useSetAtom(sessionAtom)

  const [sessionProvider, setSessionProvider] = useAtom(sessionProviderAtom)

  const logout = useCallback(async () => {
    try {
      setSessionProvider(null)
      setSession(null)

      setUser(undefined)

      Sentry.setUser(null)

      if (sessionProvider === Provider.MSAL && msal) {
        // MSAL logout is not called: only the local token cache is cleared
        await msal.clearCache()
      }
    } catch (error) {
      // Errors go to Sentry: there is no application logger yet
      Sentry.captureException(error, {
        tags: {
          feature: 'authentication',
          provider: sessionProvider,
          operation: 'logout',
        },
        contexts: {
          logout: {
            provider: sessionProvider,
            msalAvailable: !!msal,
          },
        },
        level: 'error',
      })
      throw error // Re-thrown so that the caller can handle the error
    }
  }, [msal, sessionProvider, setUser, setSession, setSessionProvider])

  return { logout }
}
